import { SET_APEX_USER_CHECKED } from './constants';

export const setApexUserChecked = (params) => ({
  type: SET_APEX_USER_CHECKED,
  params,
});



// WEBPACK FOOTER //
// ./src/containers/Login/actions.js